import axios from "../../utils/axios";

/**
 * Branding Service
 * API calls for site branding settings
 */

// Get a branding setting (admin authenticated)
export const get_branding = async (key) => {
    const response = await axios.get(`/admin/branding/${key}`);
    return response.data;
};

// Set a branding setting
export const set_branding = async (key, value) => {
    const response = await axios.post(`/admin/branding`, { key, value });
    return response.data;
};

// Upload logo
export const upload_logo = async (file) => {
    const formData = new FormData();
    formData.append('image_path', file);

    const response = await axios.post(`/admin/branding/upload-logo`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
    return response.data;
};

// Get public branding setting (no auth required, for login page)
export const get_public_branding = async (key) => {
    const response = await axios.get(`/public/branding/${key}`);
    return response.data;
};
